import { createContext } from "react";

export const rememberContext = createContext(false);

export const userLoggedIn = createContext(false);
export const userBeneFiciary = createContext("");
export const categoryIdContext = createContext(null);
export const CartCountContext = createContext(null);
